import React from 'react'
import { ProductCard } from './ProductCard'
import woman from "../pages/Images/woman.png";

export default function MoreItems() {
  return (
    <div className="my-10 bg-white rounded-md p-8">
    <h2 className="text-2xl font-medium mb-4">SIMILAR ITEMS</h2>
    <div className=" flex justify-between ">
      {[
        { productName: "Adire material", productImage: woman },
        { productName: "Adire material", productImage: woman },
        { productName: "Adire material", productImage: woman },
        { productName: "Adire material", productImage: woman },
        { productName: "Adire material", productImage: woman },
        { productName: "Adire material", productImage: woman },
      ].map((item, idx) => (
        <ProductCard key={idx} {...item} />
      ))}
    </div>
  </div>
  )
}
